export default "__VITE_ASSET__6LcMrXMb__"